var _regeneratorRuntime = require("/codebuild/output/src538327727/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/codebuild/output/src538327727/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var core = require('@sentry/core');
var helpers = require('../helpers.js');

// This is a map of integration function method to bundle file name.
var LazyLoadableIntegrations = {
  replayIntegration: 'replay',
  replayCanvasIntegration: 'replay-canvas',
  feedbackIntegration: 'feedback',
  feedbackModalIntegration: 'feedback-modal',
  feedbackScreenshotIntegration: 'feedback-screenshot',
  captureConsoleIntegration: 'captureconsole',
  contextLinesIntegration: 'contextlines',
  linkedErrorsIntegration: 'linkederrors',
  dedupeIntegration: 'dedupe',
  extraErrorDataIntegration: 'extraerrordata',
  graphqlClientIntegration: 'graphqlclient',
  httpClientIntegration: 'httpclient',
  reportingObserverIntegration: 'reportingobserver',
  rewriteFramesIntegration: 'rewriteframes',
  browserProfilingIntegration: 'browserprofiling',
  moduleMetadataIntegration: 'modulemetadata'
};
var WindowWithMaybeIntegration = helpers.WINDOW;

/**
 * Lazy load an integration from the CDN.
 * Rejects if the integration cannot be loaded.
 */
function lazyLoadIntegration(_x, _x2) {
  return _lazyLoadIntegration.apply(this, arguments);
}
function _lazyLoadIntegration() {
  _lazyLoadIntegration = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, scriptNonce) {
    var bundle, sentryOnWindow, existing, url, script, waitForLoad, currentScript, parent, integrationFn;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          bundle = LazyLoadableIntegrations[name]; // `window.Sentry` is only set when using a CDN bundle, but this method can also be used via the NPM package
          sentryOnWindow = WindowWithMaybeIntegration.Sentry = WindowWithMaybeIntegration.Sentry || {};
          if (bundle) {
            _context.next = 4;
            break;
          }
          throw new Error("Cannot lazy load integration: ".concat(name));
        case 4:
          // Bail if the integration already exists
          existing = sentryOnWindow[name]; // The `feedbackIntegration` is loaded by default in the CDN bundles,
          // so we need to differentiate between the real integration and the shim.
          // if only the shim exists, we still want to lazy load the real integration.
          if (!(typeof existing === 'function' && !('_isShim' in existing))) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", existing);
        case 7:
          url = getScriptURL(bundle);
          script = helpers.WINDOW.document.createElement('script');
          script.src = url;
          script.crossOrigin = 'anonymous';
          script.referrerPolicy = 'strict-origin';
          if (scriptNonce) {
            script.setAttribute('nonce', scriptNonce);
          }
          waitForLoad = new Promise(function (resolve, reject) {
            script.addEventListener('load', function () {
              return resolve();
            });
            script.addEventListener('error', reject);
          });
          currentScript = helpers.WINDOW.document.currentScript;
          parent = helpers.WINDOW.document.body || helpers.WINDOW.document.head || (currentScript === null || currentScript === void 0 ? void 0 : currentScript.parentElement);
          if (!parent) {
            _context.next = 20;
            break;
          }
          parent.appendChild(script);
          _context.next = 21;
          break;
        case 20:
          throw new Error("Could not find parent element to insert lazy-loaded ".concat(name, " script"));
        case 21:
          _context.prev = 21;
          _context.next = 24;
          return waitForLoad;
        case 24:
          _context.next = 29;
          break;
        case 26:
          _context.prev = 26;
          _context.t0 = _context["catch"](21);
          throw new Error("Error when loading integration: ".concat(name));
        case 29:
          integrationFn = sentryOnWindow[name];
          if (!(typeof integrationFn !== 'function')) {
            _context.next = 32;
            break;
          }
          throw new Error("Could not load integration: ".concat(name));
        case 32:
          return _context.abrupt("return", integrationFn);
        case 33:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[21, 26]]);
  }));
  return _lazyLoadIntegration.apply(this, arguments);
}
function getScriptURL(bundle) {
  var _client$getOptions;
  var client = core.getClient();
  var baseURL = (client === null || client === void 0 || (_client$getOptions = client.getOptions()) === null || _client$getOptions === void 0 ? void 0 : _client$getOptions.cdnBaseUrl) || 'https://browser.sentry-cdn.com';
  return new URL("/".concat(core.SDK_VERSION, "/").concat(bundle, ".min.js"), baseURL).toString();
}
exports.lazyLoadIntegration = lazyLoadIntegration;